import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import useProduct from "../../hooks/useProduct";
import ItemCarousel from "./ItemCarousel";
import {
  TABLET_BREAKPOINT,
  DESKTOP_BREAKPOINT,
  TABLET_COLS,
  DESKTOP_COLS
} from "../../helpers/constants";

const CarouselMobile = ({
  isHomePage,
  isEnElMundoPage,
  isTensoBlogPage,
  isSubProductPage,
  isHomePgiReplicaPage,
  isTensoBlogReplicaPgiPage,
  currentProduct
}) => {
  const { products } = useProduct();
  const [cargando, setCargando] = useState(false);
  const [columnsClass, setColumnsClass] = useState("");
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const productLinea = products?.filter(
    (prod) =>
      prod?.deleted === false &&
      prod?.visible === true &&
      prod?.type === "productoLinea" &&
      prod?._id !== currentProduct?._id
  );

  useEffect(() => {
    if (products.length > 0) {
      setCargando(true);
      setElementClass(viewportWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    setElementClass(viewportWidth);
    return () => window.removeEventListener("resize", handleWindowResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewportWidth]);

  const handleWindowResize = () => {
    setViewportWidth(window.innerWidth);
  };

  // Setting column class to father element of item
  const setElementClass = (viewportWidth) => {
    if (viewportWidth < TABLET_BREAKPOINT) {
      setColumnsClass("two-cols-mobile");
    } else if (viewportWidth >= TABLET_BREAKPOINT && viewportWidth < DESKTOP_BREAKPOINT) {
      if (productLinea.length % TABLET_COLS === 0) {
        setColumnsClass("three-cols-tablet");
      } else {
        if (productLinea.length % TABLET_COLS === 1) {
          setColumnsClass("not-three-cols-tablet");
        } else {
          setColumnsClass("three-cols-tablet");
        }
      }
    } else if (viewportWidth >= DESKTOP_BREAKPOINT) {
      if (productLinea.length % DESKTOP_COLS === 0) {
        setColumnsClass("five-cols-desktop");
      } else {
        if (productLinea.length % DESKTOP_COLS === 1) {
          setColumnsClass("not-five-cols-desktop");
        } else {
          setColumnsClass("five-cols-desktop");
        }
      }
    }
  };

  return (
    cargando && (
      <div className="carousel_mobile">
        {isHomePage ||
        isEnElMundoPage ||
        isTensoBlogPage ||
        isSubProductPage ||
        isHomePgiReplicaPage ||
        isTensoBlogReplicaPgiPage ? (
          <h3 className="in text-center">Productos de Línea</h3>
        ) : (
          <h3 className="text-left">Otros productos de línea</h3>
        )}
        <div className={`d-flex flex-wrap justify-content-center list-products ${columnsClass}`}>
          {productLinea &&
            productLinea?.map((prod, index) => <ItemCarousel key={index} prod={prod} />)}
        </div>
      </div>
    )
  );
};

export default CarouselMobile;
